import { z } from 'zod';
import { FeedbackCategory } from '@/types/feedback/feedback-category.type.ts';

export type FeedbackForm = {
    category?: FeedbackCategory,
    message?: string,
    files?: File[],
};

export function mapFeedbackFormToFormData(feedbackForm: FeedbackForm): FormData {
    const formData = new FormData();

    if (feedbackForm.category !== undefined) {
        formData.append('category', feedbackForm.category);
    }

    if (feedbackForm.message !== undefined) {
        formData.append('message', feedbackForm.message);
    }

    feedbackForm.files?.forEach((file: File, index: number) => {
        formData.append(`files[${index}]`, file);
    });

    return formData;
}

export type FeedbackFormErrors = {
    category?: string[],
    message?: string[],
    files?: (string[] | string[][]),
};

export const FeedbackFormErrorsSchema = z.object({
    category: z.string().array().optional(),
    message: z.string().array().optional(),
    files: z.array(z.string().array().optional()).optional().or(z.string().array().optional()),
});
